import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import Header from "../../components/Header/index";
import AuthService from "../../services/AuthService";
import AuthApi from "../../services/portal-api/AuthApi";
import LoadingSpinner from "../../components/LoadingSpinner";

export default class Logout extends React.Component {

    constructor(props) {
        super(props);

        let resetSuccessfully = false;
        if (typeof props.history.location.state !== 'undefined' && props.history.location.state.resetSuccessfully) {
            resetSuccessfully = true;
        }
        
        this.state = {
            isLoading: true,
            resetSuccessfully: resetSuccessfully,
        };
    }

    componentDidMount() {
        document.title = 'Logged out - duskPortal';
        document.body.className = '';

        this.logoutCallId = AuthApi.logout((response, callId) => {

            // Check if we're still interesting in this response
            if (callId !== this.logoutCallId) {
                return;
            }

            // Logged out
            AuthService.logout();
            this.setState({
                isLoading: false
            });
        });
    }

    componentWillUnmount() {
        // No longer care about any API calls in progress
        this.logoutCallId = null;
    }

    render() {
        if (!this.state.isLoading) {
            if(this.state.resetSuccessfully){
                return <Redirect to={{pathname: '/login', 'state': {showLoggedOut: false, showResetSuccessfully: true}}} />;
            } else {
                return <Redirect to={{pathname: '/login', 'state': {showLoggedOut: true, showResetSuccessfully: false}}} />;
            }
            
        }
        return <div>
            <Header isLoggedOut />
            <main className="content" role="main">
                <div className="vertab">
                    <div className="vertab--inner viewport--width">

                        <div className="container padding--100 text--center text--15">

                            <LoadingSpinner isVisible={true} />

                        </div>

                    </div>
                </div>

            </main>
        </div>;
    }
}
